import React from "react";
import FontAwesome from "react-fontawesome";
import "font-awesome/css/font-awesome.css";

const Icon = ({ name, ...props }) => <FontAwesome name={name} {...props} />;

Icon.displayName = "Icon.Library";
export default Icon;
